export default {
  data() {
    return {
      phoneReg: /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/,
    };
  },
  methods: {
    isValidPhone(phone) {
      if (!phone || phone.length < 1) return true;
      return this.phoneReg.test(phone.trim());
    },
    maskPhone(phone) {
      let p = phone;
      if (!phone || phone.trim().length < 1) return p;
      p = p.toString().replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      return p;
    },
    unmaskPhone(phone) {
      let p = phone;
      if (!phone || phone.trim().length < 1) return p;
      p = p.replace(/\D/g, '');
      return p;
    },
  },
};
